import { TaxTypePipe } from '../../shared/pipes/tax-type.pipe';

export function taxType ( taxTypePipe : TaxTypePipe ) {
  return ( value : string, types : Array<any>, key : string ) : string => taxTypePipe.transform(value, types, key);
};
